import { render, staticRenderFns } from "./DoRecord.vue?vue&type=template&id=490f84cd&scoped=true&"
import script from "./DoRecord.vue?vue&type=script&lang=js&"
export * from "./DoRecord.vue?vue&type=script&lang=js&"
import style0 from "./DoRecord.vue?vue&type=style&index=0&id=490f84cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f84cd",
  null
  
)

export default component.exports